import React from "react";
import { Button } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { useMediaQuery } from "@mui/material";
import { useLanguage } from "../context/LanguageContext.js";

const BoutonSavePeriod = ({ label, onClick, disabled = false }) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const { t } = useLanguage();

  return (
    <Button
      onClick={onClick}
      variant="outlined"
      size="small"
      startIcon={
        <SaveIcon
          sx={{
            fontSize: isMobile ? "1rem" : "0.9rem", // icône un peu plus grande sur mobile
            color: "#fff",
          }}
        />
      }
      disabled={disabled}
      sx={{
        minWidth: "auto",
        minHeight: "auto",
        textTransform: "none",
        lineHeight: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        backgroundColor: "#3399FF !important",
        borderColor: "#3399FF",
        marginLeft: isMobile ? 0 : 1,
        marginTop: 1,
        fontWeight: "bold",
        fontSize: isMobile ? "0.55rem" : "0.65rem",
        padding: isMobile ? "4px" : "2px 8px", // carré et compact sur mobile
        borderRadius: "4px",
        transition: "all 0.2s ease",
        "&:hover": {
          backgroundColor: "#027bb5",
          color: "#fff",
        },
      }}
    >
      {/* 👉 Sur mobile : pas de texte, uniquement l’icône */}
      {!isMobile && t("SavePeriods")}
    </Button>
  );
};

export default BoutonSavePeriod;
